import { Create } from 'react-admin';
import { StoreForm } from './Store.Form';

export const StoreCreate = () => {
    return (
        <Create redirect="list">
            <StoreForm />
        </Create>
    );
};
